import { render, staticRenderFns } from "./ClinicasActivasPorEstado.vue?vue&type=template&id=1e61f2a0"
import script from "./ClinicasActivasPorEstado.vue?vue&type=script&lang=js"
export * from "./ClinicasActivasPorEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports